export const enum PageTemplatesEnum {
  Questionnaire = 'questionnaire',
}

export namespace PageTemplatesMetadata {
  export type PageTemplatesMetadataCommonType = Record<string, any>;
  export namespace Questionnaire {

    export const enum RecommendationType {
      SIMPLE = 'simple',
      COMPLEX = 'complex',
    }
    export type RecommendationSimple = {
      databaseUuid: string;
      type: RecommendationType.SIMPLE;
    }
    export type RecommendationComplex = {
      databaseUuid: string;
      matchingItemDatabaseUuid: string;
      type: RecommendationType.COMPLEX;
    }
    interface IQuestionOption {
      point?: string | number;
      category?: string;
    }
    interface IQuestionCategory {
      id: string;
    }
    interface IQuestionItem {
      id: string | number;
      options?: IQuestionOption[];
      /**
       * Use point system for option value. For dropdown and radio controls only.
       */
      weightedValueMode?: boolean;
    }
    export type Questionnaire<T = PageTemplatesMetadataCommonType> = T & {
      databaseUuid: string;
      categoryDatabaseUuid: string;
      recommendationConfig?: RecommendationSimple | RecommendationComplex;
      id: string;
      pageTemplateId: string;
      questions?: IQuestionItem[];
      categories: IQuestionCategory[];
    };
  }
}

export type PageTemplatesModel<T = PageTemplatesMetadata.PageTemplatesMetadataCommonType> = {
  id: string;
  appId: string;
  name: string;
  type: PageTemplatesEnum;
  metadata: T;
  createdAt: string; // Date
  updatedAt: string; // Date
  deletedAt?: string; // Date
}
